var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 19.4577C5.05866 19.4577 1.04199 15.441 1.04199 10.4993C1.04199 5.55768 5.05866 1.54102 10.0003 1.54102C14.942 1.54102 18.9587 5.55768 18.9587 10.4993C18.9587 15.441 14.942 19.4577 10.0003 19.4577ZM10.0003 2.79102C5.75033 2.79102 2.29199 6.24935 2.29199 10.4993C2.29199 14.7493 5.75033 18.2077 10.0003 18.2077C14.2503 18.2077 17.7087 14.7493 17.7087 10.4993C17.7087 6.24935 14.2503 2.79102 10.0003 2.79102Z",
    fill: "#38879F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.86e0c746567ddd53bfaed5a850457e48.svg";
export { ForwardRef as ReactComponent };